import { store } from '@/store/store'
import Vue from 'vue'
import Router from 'vue-router'

import NotFoundView from '@/components/error/404.vue'

import InterventionCatalog from '@/components/view/InterventionCatalog/Main'
import Account from '@/components/view/allbots/Account'
import Analytic from '@/components/view/analytic/Main'
import Broadcast from '@/components/view/broadcast/Main'
import Flows from '@/components/view/flow/Flows'

Vue.use(Router)

const allLang = ['en', 'th']

const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('en')
      }
      store.dispatch('setLang', language)

      return next()
    }
  },
  {
    path: '/:lang',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('en')
      }
      store.dispatch('setLang', language)

      return next()
    },
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        redirect: 'allbots'
      },
      {
        path: 'login',
        name: 'login',
        component: function(resolve) {
          require(['@/components/login/Nigol.vue'], resolve)
        }
      },
      {
        path: 'social-login',
        name: 'social-login',
        component: function(resolve) {
          require(['@/components/login/login.vue'], resolve)
        }
      },
      {
        path: 'allbots',
        name: 'allbots',
        component: Account,
        beforeEnter: guardRoute,
        meta: {
          title: 'All Bots'
        }
      },

      // {
      //   path: 'conversation',
      //   name: 'conversation',
      //   component: Conversation,
      //   beforeEnter: guardRoute,
      //   meta: {
      //     title: 'Conversations'
      //   }
      // },

      {
        path: 'flow',
        name: 'flow',
        component: Flows,
        beforeEnter: guardRoute,
        meta: {
          title: 'Flow'
        }
      },
      {
        path: 'analytic',
        name: 'analytic',
        component: Analytic,
        beforeEnter: guardRoute,
        meta: {
          title: 'Analytic'
        }
      },
      {
        path: 'broadcast',
        name: 'broadcast',
        component: Broadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Broadcast'
        }
      },
      {
        path: 'interventioncatalog',
        name: 'interventioncatalog',
        component: InterventionCatalog,
        beforeEnter: guardRoute,
        meta: {
          title: 'Intervention Catalog'
        }
      },
      {
        // not found handler
        path: '*',
        component: NotFoundView
      }
    ]
  }
]

const router = new Router({
  routes,
  mode: 'history'
})

const title = 'ZWIZ.AI Chatbot'
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (['chat2pay', 'setup_c2p'].includes(to.name)) {
    document.title = nearestWithTitle.meta.title
  } else if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ' | ' + title
  } else {
    document.title = title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el =>
    el.parentNode.removeChild(el)
  )

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

export default router

function guardRoute(to, from, next) {
  if (!store.getters.isLoggedIn) {
    next({
      path: '/' + store.getters.currentLang + '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    if (store.state.isFacebook) {
      // if (store.state.selectedBot) {
      //   store.dispatch('updateBotDetail').then(
      //     function(response) {
      //       // console.log(response)
      //     },
      //     function(e) {
      //       next({
      //         path: '/' + store.getters.currentLang + '/login',
      //         query: { redirect: to.fullPath }
      //       })
      //     }
      //   )
      // }
      next()
    } else {
      // if (store.state.selectedBot) {
      //   store.dispatch('updateBotDetail').then(
      //     function(response) {
      //       // console.log(response)
      //     },
      //     function(e) {
      //       next({
      //         path: '/' + store.getters.currentLang + '/login',
      //         query: { redirect: to.fullPath }
      //       })
      //     }
      //   )
      // }

      next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js